/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-use-before-define */
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import moment from 'moment';
import axios from 'axios';
import useMessageDispatcher from '../../../../hooks/useMessageDispatcher';

// ===============================|| UI DIALOG - FORMS ||=============================== //

export default function DiscontinueHostel(props) {
    const [instituteLogo, setInstituteLogo] = useState('');
    const student = props?.student?.selectedStudent;
    const [date, setDate] = useState('');
    const showMessage = useMessageDispatcher();
    const downloadDocumentFunction = (fileName, type) => {
        axios
            .post(
                `/v1/utils/file/download`,
                { fileName },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then((result) => {
                if (type === 'logo') {
                    setInstituteLogo(result.data.data);
                }
            });
    };

    const getIntituteLogo = () => {
        axios
            .get(`/v1/institutes/get`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                if (result.data.data.instituteLogo !== '' || result.data.data.header !== '' || result?.data?.data?.waterMark !== '') {
                    downloadDocumentFunction(result?.data?.data?.hallTicketHeader, 'logo');
                }
            });
    };

    useEffect(() => {
        getIntituteLogo();
    }, []);
    const discontinueAdmission = () => {
        axios
            .delete(`/v1/hostel/students/vacate?studentId=${props?.student?.studentId}&date=${date}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                handlePrintInNewTab();
                showMessage({ message: result?.data?.Msg, color: 'success' });
                props.handleClose();
                props.fetchStudentsDetails(props.fetchData);
            })
            .catch((error) => {
                if (!error.response) {
                    showMessage({ message: error.message, color: 'error' });
                } else {
                    showMessage({ message: error.response.data.Msg, color: 'error' });
                }
            });
    };
    const handleGetDiscontinue = (date) => {
        setDate(date);
    };
    const handlePrintInNewTab = () => {
        const htmlContent = `
    <html>
      <head>
        <title>Hostel Discontinue Slip</title>
        <style>
          body {
            padding: 10px;
            color: #000;
          }
          .paper {
            margin: auto;
            border: 2px solid #04326D;
            border-radius: '10px'
            background-color:rgb(246, 242, 218);
            font-family: "'Georgia', serif";
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            padding-bottom: 20px;
          }
          .header {
            text-align: center;
            padding: 20px;
            border-bottom: 1px solid #d3d3d3;
          }
          .header-line {
            border-bottom: 2px solid #d0464d;
            margin-top: 5px;
          }
          .title {
            font-size: 15px;
            font-weight: 500;
            color: black;
            margin-top: 10px;
          }
          .section-title {
            color: #04326D;
            font-weight: bold;
            text-align: center;
            text-transform: uppercase;
            margin: 30px 0 20px;
            font-size: 16px;
            letter-spacing: 0.5px;
          }
          .info-container {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0 20px;
          }
          .info-group {
            width: 48%;
            margin-bottom: 12px;
          }
          .info-label {
            font-weight: bold;
            color: #333;
          }
          .info-value {
            color: #000;
          }
          .signature {
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            margin-top: 40px;
          }
          .divider {
            border-bottom: 2px dashed #999;
            margin: 40px 20px;
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <div class="paper">
          <div class="header">
            <div><img src=${instituteLogo} alt="Logo" height="80" /></div>
            <div class="header-line"></div>
            <div class="title">Hostel Discontinue Slip</div>
          </div>

          <div class="section-title">Warden Copy</div>
          <div class="info-container">
            <div class="info-group"><span class="info-label">Name:</span> <span class="info-value">${
                student?.studentMini?.studentName
            }</span></div>
            <div class="info-group"><span class="info-label">Roll No:</span> <span class="info-value">${student?.rollNo}</span></div>
            <div class="info-group"><span class="info-label">Course:</span> <span class="info-value">${
                student?.studentMini?.courseName
            }</span></div>
            <div class="info-group"><span class="info-label">Phone:</span> <span class="info-value">${
                student?.studentMini?.phone
            }</span></div>
            <div class="info-group"><span class="info-label">Hostel:</span> <span class="info-value">${
                student?.room?.building?.name
            }</span></div>
            <div class="info-group"><span class="info-label">Room Type:</span> <span class="info-value">${
                student?.room?.hostelRoomCategory?.name
            }</span></div>
            <div class="info-group"><span class="info-label">Date of Discontinue:</span> <span class="info-value">${moment(
                date,
                'YYYY-MM-DD'
            ).format('DD-MM-YYYY')}</span></div>
          </div>
          <div class="signature">
            <div>Date: ________________</div>
            <div>Authorized Signatory*</div>
          </div>
          <div class="divider"></div>          
          <div class="header">
            <div><img src=${instituteLogo} alt="Logo" height="80" /></div>
            <div class="header-line"></div>
            <div class="title">Hostel Discontinue Slip</div>
          </div>
          <div class="section-title">Student Copy</div>
          <div class="info-container">
            <div class="info-group"><span class="info-label">Name:</span> <span class="info-value">${
                student?.studentMini?.studentName
            }</span></div>
            <div class="info-group"><span class="info-label">Roll No:</span> <span class="info-value">${student?.rollNo}</span></div>
            <div class="info-group"><span class="info-label">Course:</span> <span class="info-value">${
                student?.studentMini?.courseName
            }</span></div>
            <div class="info-group"><span class="info-label">Phone:</span> <span class="info-value">${
                student?.studentMini?.phone
            }</span></div>
            <div class="info-group"><span class="info-label">Hostel:</span> <span class="info-value">${
                student?.room?.building?.name
            }</span></div>
            <div class="info-group"><span class="info-label">Date of Joining:</span> <span class="info-value">${moment(
                student?.joinedDate,
                'YYYY-MM-DD'
            ).format('DD-MM-YYYY')}</span></div>
            <div class="info-group"><span class="info-label">Room Type:</span> <span class="info-value">${
                student?.room?.hostelRoomCategory?.name
            }</span></div>            
            <div class="info-group"><span class="info-label">Date of Discontinue:</span> <span class="info-value">${moment(
                date,
                'YYYY-MM-DD'
            ).format('DD-MM-YYYY')}</span></div>
          </div>
          <div class="signature">
            <div>Date: ________________</div>
            <div>Authorized Signatory*</div>
          </div>
          </div>
        </div>
      </body>
    </html>
    `;

        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
    };

    return (
        <div>
            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                {props.open && (
                    <>
                        <DialogTitle id="form-dialog-title" width={500}>
                            Are you sure you want to Discontinue Hostel for {props?.student?.studentName} ?
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sx={{ mt: 2 }}>
                                    <TextField
                                        type="date"
                                        id="joinDate"
                                        name="joinDate"
                                        required
                                        label="Discontinue Date"
                                        onChange={(e) => {
                                            handleGetDiscontinue(e.target.value);
                                        }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'end', gap: 2 }}>
                                    <Button variant="contained" onClick={props.handleClose} color="error">
                                        Cancel
                                    </Button>
                                    <Button type="button" variant="contained" onClick={discontinueAdmission}>
                                        Discontinue
                                    </Button>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions />
                    </>
                )}
            </Dialog>
        </div>
    );
}
